import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function formatWeekRange(mondayDate) {
  const sunday = new Date(mondayDate);
  sunday.setDate(sunday.getDate() + 6);

  const fmt = (d) =>
    d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

  return `${fmt(mondayDate)} – ${fmt(sunday)}`;
}

function WeekNavigator({ weekStart, onPrev, onNext, status }) {
  const { t } = useTranslation('scheduler');
  const isPublished = status === 'PUBLISHED';

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-1">
        <button
          onClick={onPrev}
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100 transition-colors"
          aria-label={t('weekNav.prevWeek')}
        >
          <ChevronLeft size={15} />
          <span className="hidden sm:inline">{t('weekNav.prevWeek')}</span>
        </button>

        <span className="px-3 py-1.5 text-sm font-semibold text-gray-800 min-w-[200px] text-center">
          {formatWeekRange(weekStart)}
        </span>

        <button
          onClick={onNext}
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100 transition-colors"
          aria-label={t('weekNav.nextWeek')}
        >
          <span className="hidden sm:inline">{t('weekNav.nextWeek')}</span>
          <ChevronRight size={15} />
        </button>
      </div>

      <span
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
          isPublished ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
        }`}
      >
        {isPublished ? t('statusPublished') : t('statusDraft')}
      </span>
    </div>
  );
}

export default WeekNavigator;
